/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_FlavorInputs */

const en_edit_flavor = /** @type {(inputs: Edit_FlavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Flavor`)
};

const es_edit_flavor = /** @type {(inputs: Edit_FlavorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar sabor`)
};

/**
* | output |
* | --- |
* | "Edit Flavor" |
*
* @param {Edit_FlavorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_flavor = /** @type {((inputs?: Edit_FlavorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_FlavorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_flavor(inputs)
	return es_edit_flavor(inputs)
});